module.exports = __webpack_public_path__ + "0f25118032df5fd7c0a5ffac65f6a63f.jpg";